export default "__VITE_ASSET__C9KzYn6T__"